import { ref } from 'vue'

const POLL_INTERVAL_MS = 2000
const MAX_POLLS = 60

export function usePdfDownload() {
  const downloading = ref(false)
  const error = ref(null)

  async function download(pdfUrl) {
    downloading.value = true
    error.value = null
    try {
      const startRes = await fetch(pdfUrl, { headers: { Accept: 'application/json' } })
      if (!startRes.ok) throw new Error('Échec démarrage génération PDF')
      const { poll_url, download_url } = await startRes.json()

      for (let i = 0; i < MAX_POLLS; i++) {
        await new Promise(r => setTimeout(r, POLL_INTERVAL_MS))
        const pollRes = await fetch(poll_url, { headers: { Accept: 'application/json' } })
        const { status, message } = await pollRes.json()
        if (status === 'ready') {
          window.location.href = download_url
          return
        }
        if (status === 'error') throw new Error(message || 'Erreur génération PDF')
      }
      throw new Error('Délai de génération dépassé')
    } catch (e) {
      error.value = e.message
    } finally {
      downloading.value = false
    }
  }

  return { downloading, error, download }
}
